const createImageSizesAttr = (sizes: number[], mediaQueries: string[]) => {
  sizes.sort((a, b) => b - a);
  const allImageSize = sizes.map((size) => `${size}w`);
  return mediaQueries.map((mediaQuery, index) => `${mediaQuery} ${allImageSize[index]}`).join(', ');
};

export default createImageSizesAttr;
